<script>
    import * as d3 from "d3";
    import drmetrics from "drmetrics";
    import * as druid from "@saehrimnir/druidjs/dist/druid.js";

    let XG;
    (async () => { 
        await wait(1000)
        await XGBoost
        let modelXG = await d3.blob("./data/model.xgboost")
        XG = XGBoost.loadFromModel(await modelXG.arrayBuffer(), {'eta': 0.3, 'max_depth': 5, objective: 'rank:pairwise', })
    })()

    import dark from "smelte/src/dark"
    const darkMode = dark()
    $darkMode = true;

    import { Select, Spacer, Button, ProgressCircular, Switch, RadioButtonGroup } from "smelte";
    import Bar from "./Bar.svelte";
    import Scatterplot from "./Scatterplot.svelte";
    import DotChart from "./DotChart.svelte";
    import StarPlot from "./StarPlot.svelte";

    let data = new Map();
    let datasets = [];
    let selected_dataset;
    let loading = true;
    $: total = data.length;

    let metric_columns = ["outlying", "skewed", "clumpy", "sparse", "striated", "convex", "skinny", "stringy", "monotonic", "abw", "cal", "dsc", "hm", "sc", "SepMe_cp_a", "SepMe_ce_a", "auclog", "cca", "lcmc", "nerv", "nlm", "stress", "trustworthiness", "tnc", "human_ranking", , "model_ranking"]
    let model_columns = ['SepMe_cp_a', 'stress', 'nerv', 'dsc', 'auclog', 'skinny', 'convex', 'cca', 'SepMe_ce_a', 'sc', 'monotonic', 'abw', 'striated', 'clumpy', 'outlying', 'stringy', 'hm', 'sparse', 'cal', 'trustworthiness', 'lcmc', 'skewed', 'nlm'];
    function rowData(v) {
        let res = {metrics: {}}
        metric_columns.forEach(key => {
            res.metrics[key] = d3.mean(v, d => d[key]);
        })
        res.count = v.length;
        //res.unique = new Set(...v.map(d => d.subject_id)).size;
        res.name = v[0].name;
        res.dataset = v[0].dataset;
        res.dr = v[0].dr;
        res.x = v[0].UMAP_1;
        res.y = v[0].UMAP_2;
        return res
    }

    (async () => {
        data = (await d3.csv("./data/combined_with_ranking.csv", d3.autoType))
        console.log("odata", data)
        data = d3.rollup(data, rowData, d => d.dataset, d => d.name)
        console.log("DATA", data)
        datasets = [...data.keys()]
        selected_dataset = datasets[0];
        setTimeout(() => loading = false, 500);
    })()

    let perPageOptions = [10, 20, 50];
    let perPage = 10;
    let page = 1;
    $: offset = (page * perPage) - perPage;
    $: selected = data.has(selected_dataset) ? [...data.get(selected_dataset).values()] : []
    //$: console.log(selected)
    $: sorted = selected
        .sort((a, b) => b.metrics.model_ranking - a.metrics.model_ranking)
        .map((d,i) => {d.i = i; return d})
        .slice(offset, perPage + offset);

    //$: console.log("sorted data", sorted)
    $: total = selected.length;
    $: pagesCount = Math.ceil(total / perPage) || 0;
    let margin = 20;
    let cellSize = 70;
    
    let colorscaleLabel = d3.scaleOrdinal(d3.schemeTableau10);

    $: model_ranking_abs_max = d3.max(selected.values(), d => Math.abs(d.metrics.model_ranking))
    //$: model_ranking_scale = d3.scaleLinear([-model_ranking_abs_max, model_ranking_abs_max], [margin, cellSize * 2 - margin]).nice();
    $: model_ranking_scale = d3.scaleLinear([-2, 2], [margin, cellSize * 2 - margin]).nice();
    $: model_ranking_colorScale = d3.scaleSequential(d3.interpolateRdYlBu).domain([-1.2, 1.2]).clamp(true)
    $: model_rankings = selected.map(d => d.metrics.model_ranking)
    //$: console.log("model_rankings", model_rankings, model_ranking_abs_max)

    let metrics_hierarchy = {
        "Scagnostics": ["outlying", "skewed", "clumpy", "sparse", "striated", "convex", "skinny", "stringy", "monotonic"],
        "Cluster Separability": ["cal", "dsc", "hm", "sc"],
        "Stress": ["nlm", "cca", "stress"],
        "Small Neighborhoods": ["lcmc", "trustworthiness", "nerv"],
        "All Neighborhoods": ["auclog"],
    };
    //$: scagnostics_abs_max = d3.max(sorted.values(), d => Math.abs(Math.max(...metrics_hierarchy.Scagnostics.map(k => d.metrics[k]))));
    $: scagnostics_scale = d3.scaleLinear().domain([0, 1]).range([0, cellSize * 2 - 2 * margin]).nice();
    $: scagnostics_colorScale = d3.scaleOrdinal(d3.schemeSet1).domain(metrics_hierarchy.Scagnostics);

    $: cluster_separability_scale = d3.scaleLinear().domain([0, 1]).range([0, cellSize * 2 - 2 * margin]).nice();
    $: cluster_separability_colorScale = d3.scaleOrdinal(d3.schemeDark2).domain(metrics_hierarchy["Cluster Separability"]);

    $: stress_scale = d3.scaleLinear().domain([0, 1]).range([0, cellSize * 2 - 2 * margin]).nice();
    $: stress_colorScale = d3.scaleOrdinal(d3.schemePastel1.slice(0, 3)).domain(metrics_hierarchy.Stress);

    $: sm_nbh_scale = d3.scaleLinear().domain([0, 1]).range([0, cellSize * 2 - 2 * margin]).nice();
    $: sm_nbh_colorScale = d3.scaleOrdinal(d3.schemePastel1.slice(3, 6)).domain(metrics_hierarchy["Small Neighborhoods"]);

    $: all_nbh_scale = d3.scaleLinear().domain(d3.extent(selected, d => d.metrics.auclog)).range([0, cellSize * 2 - 2 * margin]).nice();
    $: all_nbh_colorScale = d3.scaleOrdinal(d3.schemeDark2).domain(metrics_hierarchy["All Neighborhoods"]);

    const select_dataset_label = "Select dataset";

    async function get_projection(d) {
        if (d.scatterplot) {
            return {
                data: d.scatterplot,
                accessor_x: d => d[0],
                accessor_y: d => d[1],
                accessor_label: (_, i) => d.labels[i],
                accessor_img: null,
            }
        }
        let D =  await d3.csv(`./data/${d.dataset}/human_sample/${d.name}.csv`, d3.autoType);
        let accessors = D.columns.filter(d => d != "filename" && d != "labels");
        let accessor_label = (d, i) => D[i].labels;
        let accessor_img = (_, i) => `./data/${d.dataset}/thumbnails/${D[i].filename}.png`;
        return {
            data: D,
            accessor_x: d => d[accessors[0]],
            accessor_y: d => d[accessors[1]],
            accessor_label: accessor_label,
            accessor_img: accessor_img,
        }
    }


    function wait(t) {
        return new Promise(res => window.setTimeout(res, t));
    }

    let arrowSvg;
    $: if (arrowSvg) d3.select(arrowSvg)
        .attr("width", arrowSvg.parentNode.clientWidth)
        .attr("height", arrowSvg.parentNode.clientHeight);

    window.onresize = () => {
        d3.select(arrowSvg)
            .attr("width", arrowSvg.parentNode.clientWidth)
            .attr("height", arrowSvg.parentNode.clientHeight);
        listRowsPositions = computeListRowsPositions(listRows, selected_dataset)
    }

    function mainScroll(event) {
        listRowsPositions = computeListRowsPositions(listRows)
    }

    function computeListRowsPositions(listRows) {
        listRows = listRows.filter(d => d)
        if (listRows.length <= 0) return [];
        let parentBox = listRows[0].parentNode.getBoundingClientRect();
        let [x, y] = [
            d3.scaleLinear().domain(d3.extent(selected, d => d.x)).range([margin, 350 - margin]),
            d3.scaleLinear().domain(d3.extent(selected, d => d.y)).range([margin, 350 - margin])
        ]
        let D = selected.map((d) => [x(d.x) + 16, y(d.y) + 16]) // "+number" is the paddingSize

        let res = listRows.filter((d, i) => d != null && i < sorted.length).map((r, i) => {
            const box = r.getBoundingClientRect();
            //console.log(box)
            return {
                rowLeft: box.left, 
                rowTop: box.top + box.height / 2 + window.pageYOffset - r.parentNode.offsetTop, 
                pointIndex: sorted[i].i,
                pointLeft: D[sorted[i].i][0],
                pointTop: D[sorted[i].i][1],
            }
        })
        res = res.filter(d => {
            return d.rowTop > 0 && d.rowTop <= (parentBox.height)
        })
        return res;
    }

    let listRows = [];
    let listRowsPositions = [];
    $: if (listRows.length > 0) listRowsPositions = computeListRowsPositions(listRows, selected_dataset)

    let pointsContainer;
    let showImages = false;

    async function upload(event) {
        try {
            loading = true;
            const reader = new FileReader();
            const name = event.target.files[0].name;
            data = new Map();
            datasets = [name];
            selected_dataset = null;
            reader.addEventListener("load",  (async (event) => {
                try {
                    await(50)
                    const file_string = event.target.result;
                    const D = d3.csvParse(file_string, d3.autoType);
                    const labels = D.map(d => d.class);
                    const names = D.map(d => d.name);
                    const values = D.map(d => D.columns.filter(d => d != "class" && d != "name").map(key => d[key]));
                    const X = druid.Matrix.from(values)
                    const P = tasklist.map(({dr, parameter}) => {
                        return new Promise(async (resolve) => {
                            try {
                                const Y = druid[dr].transform(X, ...parameter);
                                const D = new drmetrics.Data(X, Y, labels);
                                let M = {
                                        'SepMe_cp_a' : drmetrics.SepMe_cp_a(D),
                                        'stress':  drmetrics.Stress(D),
                                        'nerv':  drmetrics.NeRV(D),
                                        'dsc':  drmetrics.DSC(D),
                                        'auclog':  drmetrics.AUClogRNX(D),
                                        'skinny':  drmetrics.Skinny(D),
                                        'convex':  drmetrics.Convex(D),
                                        'cca':  drmetrics.CCA(D),
                                        'SepMe_ce_a':  drmetrics.SepMe_ce_a(D),
                                        'sc':  drmetrics.SC(D),
                                        'striated':  drmetrics.Striated(D),
                                        'clumpy':  drmetrics.Clumpy(D),
                                        'outlying':  drmetrics.Outlying(D),
                                        'stringy':  drmetrics.Stringy(D),
                                        'monotonic':  drmetrics.Monotonic(D),
                                        'hm':  drmetrics.HM(D),
                                        'sparse':  drmetrics.Sparse(D),
                                        'trustworthiness':  drmetrics.Trustworthiness(D),
                                        'lcmc':  drmetrics.LCMC(D),
                                        'skewed':  drmetrics.Skewed(D),
                                        'nlm':  drmetrics.NLM(D),
                                        "abw":  drmetrics.ABW(D),
                                        "cal":  drmetrics.CAL(D),
                                    }
                                M.model_ranking = XG.predict([model_columns.map(key => M[key])])[0];

                                resolve({
                                    "metrics": M,
                                    "count": 1,
                                    "name": `${name}_${dr}_${parameter.join("_")}`,
                                    "dataset": name,
                                    "dr": dr,
                                    "scatterplot": Y.to2dArray,
                                    "labels": labels,            
                                })
                            } catch(e) {
                                window.alert(e);
                                location.reload();
                            }
                        })
                    });
                    Promise.allSettled(P).then(result => {
                        const res = result
                            .filter(d => d.status == "fulfilled")
                            .map(d => d.value)
                            
                        const scales = model_columns.map(key => {
                            const s = d3.scaleLinear()
                            s.domain(d3.extent(res, d => d.metrics[key]))
                            s.range([0, 1])
                            return s;
                        })
                        for (const row of res) {
                            model_columns.forEach((key, i) => {
                                row.metrics[key] = scales[i](row.metrics[key]);
                            })
                        }
                        const X = res.map(row => model_columns.map((key, i) => row.metrics[key]));
                              
                        const Y = druid.UMAP.transform(X);
                        for (let i = 0; i < res.length; ++i) {
                            res[i].x = Y[i][0];
                            res[i].y = Y[i][1];
                        }
                        data.set(name, res);
                        selected_dataset = name;
                        console.log("DATA", data);
                        setTimeout(() => loading = false, 500);
                    })
                } catch(e) {
                    window.alert(e);
                    location.reload();
                }
            }))

            reader.readAsText(event.target.files[0]);
        } catch(e) {
            window.alert(e);
            location.reload();
        }
    }

    let tasklist = [
        {dr: "UMAP", parameter: [1, 1]},
        {dr: "UMAP", parameter: [1, .8]},
        {dr: "UMAP", parameter: [1, .5]},
        {dr: "MDS", parameter: []},
        {dr: "PCA", parameter: []},
        {dr: "FASTMAP", parameter: []},
        {dr: "ISOMAP", parameter: [10]},
        {dr: "ISOMAP", parameter: [30]},
        {dr: "ISOMAP", parameter: [60]},
        {dr: "LLE", parameter: [10]},
        {dr: "LLE", parameter: [30]},
        {dr: "LLE", parameter: [60]},
        {dr: "LTSA", parameter: [10]},
        {dr: "LTSA", parameter: [30]},
        {dr: "LTSA", parameter: [60]},
        {dr: "TSNE", parameter: [50, 5]},
        {dr: "TSNE", parameter: [25, 5]},
        {dr: "TSNE", parameter: [10, 5]},
        {dr: "LSP", parameter: [50, 20]},
        {dr: "LSP", parameter: [30, 10]},
    ]

    let inputUpload;
    let listContainer;

    async function scroll_to_row({detail}) {
        page = Math.floor(detail.index / perPage) + 1;
        const o = (detail.index % perPage);
        const box = listRows[0].getBoundingClientRect();
        console.log(listRows[0])
        console.log("event", detail.index, page, o, o * box.height, box.height)
        await wait(50);
        listRows[o].classList.toggle("highlight");
        listRows[o].addEventListener("transitionend", () => {
            console.log()
            listRows[o].classList.remove("highlight")
        })
        console.log("scrollto", o * box.height);
        listContainer.scrollTo({
            top: o * box.height,
            behavior: "smooth"
        })
    }

    let show_modal = false;
    let modal_index = null;
    let typeIDW = "idw";

</script>
{#if show_modal}
<div id="modal">
    <section>
        <div style="display: flex; align-items: center; padding-bottom: .5rem;">
            <Switch label="Show images" bind:value={showImages}/>
            <Spacer />
            <div style="display: inline-flex; align-items: center;">
                <svg width="1rem" height="1rem" style="margin: .5rem;">
                    <rect width="1rem" height="1rem" fill={colorscaleLabel(sorted[modal_index].dr)}></rect>
                </svg>
                {sorted[modal_index].dr} {sorted[modal_index].name.split(sorted[modal_index].dr)[1].split(["_"]).filter(d => d).join(", ")}
            </div>
            <Spacer />
            <Button add="mx-1" dark={$darkMode} small icon="close" on:click={() => show_modal = false}></Button>
        </div>
        {#await get_projection(sorted[modal_index])}
            <div class="spinner_container" style="width: {500}px; height: {500}px; ">
                <ProgressCircular />
            </div>
        {:then D}
            <Scatterplot 
                data={D.data} 
                accessor_x={D.accessor_x} 
                accessor_y={D.accessor_y} 
                accessor_label={D.accessor_label} 
                accessor_img={D.accessor_img}
                colorscaleLabel={d3.scaleOrdinal(d3.schemeDark2)}
                width={500} 
                height={500} 
                point_style={showImages ? "img" : "circle"} 
                w={showImages ? 15 : 3}
                withTitle={true}
            />                       
        {/await}
    </section>
</div>
{/if}
<div id="container">
    <input bind:this={inputUpload} style="visibility: hidden" type="file" on:change={upload} accept=".csv">
    <nav style="grid-area: nav;">
        <img style="height: 2rem; padding-right: 0.5rem" src="./favicon.png" alt="logo" /><b>DumbleDR</b>
        <Spacer />
        <Select bind:value={selected_dataset} label={select_dataset_label} items={datasets} on:change={() =>page = 1}/>
        <div style="width: 1rem"></div>
        <Button add="mx-1" dark={$darkMode} small icon={$darkMode ? "wb_sunny" : "nights_stay"} on:click={() => $darkMode = !$darkMode}></Button>
        <Button add="mx-1" dark={$darkMode} small icon="file_upload" on:click={() => inputUpload.click()}></Button>
    </nav>
    <header class="aside" style="border-bottom-style: double !important; grid-area: data;">
        <article>
            <section style="grid-column: 1;">
                MetaPlot
            </section>
        </article>
        <article>
            <section style="grid-column: 1;">
                <RadioButtonGroup
                    small={true}
                    items={[
                        {value: "voronoi", label: "Voronoi"}, 
                        {value: "idw", label: "Inverse Distance Weighting (IDW)"}
                        ]} 
                    bind:selected={typeIDW} />
            </section>
        </article>
    </header>

    <aside style="grid-area: aside;" bind:this={pointsContainer}>
        {#if !loading}
            <Scatterplot 
                data={selected} 
                accessor_x={(d) => d.x} 
                accessor_y={(d) => d.y} 
                accessor_label={(d, i) => selected[i]?.dr} 
                showIDW={true}
                typeIDW={typeIDW}
                valuesIDW={model_rankings}
                colorscaleLabel={colorscaleLabel}
                scaleIDW={model_ranking_colorScale}
                on:click={scroll_to_row}
            />
        {/if}
    </aside>
    <header class="main" style="border-bottom-style: double !important; grid-area: header;">
        <article>
            <section>Rank</section>
            <section>Scatterplot</section>
            <section>DR</section>
            <section>Ranking<hr />Human Hearts</section>
            <section>Scagnostics</section>
            <section>Cluster Separability</section>
            <section>Stress</section>
            <section>Small Neighborhoods</section>
            <section>All Neighborhoods</section>
        </article>
        <article>
            <section></section>
            <section>
                <Switch label="Show images" bind:value={showImages}/>
            </section>
            <section></section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; margin-bottom: -1rem;"><span style="padding: .2rem; font-size: .6rem !important;">Model Ranking</span></small>
                <Bar 
                    scale={model_ranking_scale}
                    colorscale={model_ranking_colorScale}
                    width={cellSize * 2}
                    height={cellSize}
                    margin={margin}
                    ticks={5}
                    better={"bigger"}
                    header={true}
                />
            </section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; ">
                    {#each metrics_hierarchy["Scagnostics"] as m}
                        <span style="padding: .2rem; font-size: .6rem !important;"><span style="font-size: .6rem !important; color: {scagnostics_colorScale(m)} !important">✕</span> {m}</span>
                    {/each}
                </small>
            </section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; ">
                    {#each metrics_hierarchy["Cluster Separability"] as m}
                        <span style="padding: .2rem; font-size: .6rem !important;"><span style="font-size: .6rem !important; color: {cluster_separability_colorScale(m)} !important">✕</span> {m}</span>
                    {/each}
                </small>
            </section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; ">
                    {#each metrics_hierarchy["Stress"] as m}
                        <span style="padding: .2rem; font-size: .6rem !important;"><span style="font-size: .6rem !important; color: {stress_colorScale(m)} !important">▬</span> {m}</span>
                    {/each}
                </small>
            </section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; ">
                    {#each metrics_hierarchy["Small Neighborhoods"] as m}
                        <span style="padding: .2rem; font-size: .6rem !important;"><span style="font-size: .6rem !important; color: {sm_nbh_colorScale(m)} !important">▬</span> {m}</span>
                    {/each}
                </small>
            </section>
            <section>
                <small style="display: flex; flex-wrap: wrap; justify-content: space-between; ">
                    {#each metrics_hierarchy["All Neighborhoods"] as m}
                        <span style="padding: .2rem; font-size: .6rem !important;"><span style="font-size: .6rem !important; color: {all_nbh_colorScale(m)} !important">▬</span> {m}</span>
                    {/each}
                </small>
            </section>
        </article>
    </header>
    <main style="grid-area: main;" on:scroll={mainScroll} bind:this={listContainer}>
        {#if loading}
            <div class="flex justify-between items-center text-gray-700 text-sm w-full h-16 flex justify-between items-center text-gray-700 text-sm w-full h-16  flex justify-between items-center text-gray-700 text-sm w-full h-16 flex justify-between items-center text-gray-700 text-sm w-full h-16  ">
                <Spacer />
                <ProgressCircular />
                <Spacer />
            </div>
        {:else}
            {#each sorted as d, i}
            <article bind:this={listRows[i]}>
                <section style="font-size: 1.5rem; font-weight: 900;">
                    {d.i + 1}<sup style="font-size: .6em; font-weight: 900;">{(() => {
                        switch(d.i) {
                            case 0: return "st"
                            case 1: return "nd"
                            case 2: return "rd"
                            default: return "th"
                        }
                    })()}</sup>
                </section>
                <section>
                    {#await get_projection(d)}
                        <div class="spinner_container" style="width: {cellSize * 2}px; height: {cellSize * 2}px; ">
                            <ProgressCircular />
                        </div>
                    {:then D}
                        <Scatterplot 
                            data={D.data} 
                            accessor_x={D.accessor_x} 
                            accessor_y={D.accessor_y} 
                            accessor_label={D.accessor_label} 
                            accessor_img={D.accessor_img}
                            colorscaleLabel={d3.scaleOrdinal(d3.schemeDark2)}
                            width={cellSize * 2} 
                            height={cellSize * 2} 
                            point_style={showImages ? "img" : "circle"} 
                            w={showImages ? 5 : 1.5}
                            on:click={() => {
                                console.log(D, d, i)
                                modal_index = i;
                                show_modal = true;
                            }}
                        />                       
                    {/await}
                </section>
                <section>
                    <svg width="1rem" height="1rem" style="margin: .5rem;">
                        <rect width="1rem" height="1rem" fill={colorscaleLabel(d.dr)}></rect>
                    </svg>
                    {d.dr}
                    <br/>
                    {d.name.split(d.dr)[1].split(["_"]).filter(d => d).join(", ")}
                </section>
                <section>
                    <Bar 
                        scale={model_ranking_scale}
                        colorscale={model_ranking_colorScale}
                        width={cellSize * 2}
                        height={cellSize}
                        margin={margin}
                        value={d.metrics.model_ranking}
                        ticks={5}
                        better={"bigger"}
                    />
                    <StarPlot
                        width={cellSize * 2}
                        height={cellSize}
                        margin={margin}
                        value={d.metrics.human_ranking}
                    />
                </section>
                <section>
                    <DotChart 
                        scale={scagnostics_scale}
                        colorscale={scagnostics_colorScale}
                        width={cellSize * 2}
                        height={cellSize * 2}
                        margin={margin}
                        ticks={5}
                        value={metrics_hierarchy.Scagnostics.map(key => [key, d.metrics[key]])}
                        style="cross"
                        better={null}
                    />
                </section>
                <section>
                    <DotChart 
                        scale={cluster_separability_scale}
                        colorscale={cluster_separability_colorScale}
                        width={cellSize * 2}
                        height={cellSize * 1.5}
                        margin={margin}
                        ticks={5}
                        value={metrics_hierarchy["Cluster Separability"].map(key => [key, d.metrics[key]])}
                        style="cross"
                        better={"bigger"}
                    />
                </section>
                <section>
                    <DotChart 
                        scale={stress_scale}
                        colorscale={stress_colorScale}
                        width={cellSize * 2}
                        height={cellSize}
                        margin={margin}
                        ticks={5}
                        value={metrics_hierarchy["Stress"].map(key => [key, d.metrics[key]])}
                        style="bar"
                        better={null}
                    />
                </section>
                <section>
                    <DotChart 
                        scale={sm_nbh_scale}
                        colorscale={sm_nbh_colorScale}
                        width={cellSize * 2}
                        height={cellSize}
                        margin={margin}
                        ticks={5}
                        value={metrics_hierarchy["Small Neighborhoods"].map(key => [key, d.metrics[key]])}
                        style="bar"
                        better={null}
                    />
                </section>
                <section>
                    <DotChart 
                        scale={all_nbh_scale}
                        colorscale={all_nbh_colorScale}
                        width={cellSize * 2}
                        height={cellSize}
                        margin={margin}
                        ticks={3}
                        value={metrics_hierarchy["All Neighborhoods"].map(key => [key, d.metrics[key]])}
                        style="bar"
                        better={null}
                    />
                </section>
            </article>
            {/each}
        {/if}
    </main>
    <footer style="grid-area: footer;" class="flex justify-between items-center text-gray-700 text-sm w-full h-16 flex justify-between items-center text-gray-700 text-sm w-full h-16  flex justify-between items-center text-gray-700 text-sm w-full h-16 flex justify-between items-center text-gray-700 text-sm w-full h-16  ">
        <Spacer />
        <div class="mr-1 py-1">
        Rows per page:
        </div>
        <Select
            class="w-16 h-8 mb-5"
            remove="select"
            replace={{ "pt-6": "pt-4" }}
            inputWrapperClasses={(c) => c.replace("mt-2", "").replace("pb-6", "")}
            appendClasses={(c) => c.replace("pt-4", "pt-3").replace("pr-4", "pr-2")}
            noUnderline
            dense
            bind:value={perPage}
            items={perPageOptions}
        
        />
        <Spacer />
        <div>{offset}-{offset + perPage > total ? total : offset + perPage} of {total}</div>
        <Button
            color="gray"
            text
            dark
            remove="px-4 px-3"
            iconClasses={c => c.replace("p-4", "")}
            disabledClasses={(c) => 
                c
                    .replace("text-white", "text-gray-200")
                    .replace("bg-gray-300", "bg-transparent")
                    .replace("text-gray-700", "")
            }
            disabled={(page - 1) < 1}
            icon="keyboard_arrow_left"
            on:click={() => {
                page -= 1;
            }} />
        <Button
            color="gray"
            text
            dark
            remove="px-4 px-3"
            iconClasses={c => c.replace("p-4", "")}
            disabledClasses={(c) => 
                c
                    .replace("text-white", "text-gray-200")
                    .replace("bg-gray-300", "bg-transparent")
                    .replace("text-gray-700", "")
            }
            disabled={page === pagesCount}
            icon="keyboard_arrow_right"
            on:click={() => {
                page += 1;
            }} />
        
    </footer>
    <aside id="arrows">
        {#if !loading}
            <svg bind:this={arrowSvg}>

                <defs>
                    <marker id="arrow" markerWidth="10" markerHeight="10" refX="6" refY="3" orient="0" markerUnits="strokeWidth">
                        <path d="M0,0 L0,6 L9,3 Z" fill={$darkMode ? "white" : "#333"} />
                    </marker>
                    <filter id="f3" x="-100%" y="-100%" width="400%" height="400%">
                        <feOffset result="offOut" in="SourceAlpha" dx="0" dy={$darkMode ? "3" : "6"} />
                        <feGaussianBlur result="blurOut" in="offOut" stdDeviation="4" />
                        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
                    </filter>
                </defs>
                {#each listRowsPositions as r, i}
                    <!-- d="M {r.pointLeft} {r.pointTop} Q {r.pointLeft + margin} {r.pointTop} {(r.pointLeft + r.rowLeft) / 2} {(r.pointTop + r.rowTop) / 2} T {r.rowLeft} {r.rowTop}" -->
                    <g filter="url(#f3)">
                        <path
                            d="M {r.pointLeft} {r.pointTop} Q {r.pointLeft + margin} {r.pointTop} {(r.pointLeft + (r.rowLeft - margin)) / 2} {(r.pointTop + r.rowTop) / 2} T {r.rowLeft - margin} {r.rowTop} T {r.rowLeft} {r.rowTop}"
                            fill="none"
                            stroke={$darkMode ? "white" : "#333"}
                            stroke-width=2
                            marker-end="url(#arrow)"
                        ></path>
                    </g>
                {/each}
            </svg>
        {/if}
    </aside>
</div>

<style>
    * {
        font-family: "Open Sans", sans-serif;
        font-weight: 200;
        font-size: 14px;
    }

    :global(svg) {
        font-family: "Open Sans", sans-serif;
    }

    .spinner_container {
        display: flex;
        justify-content: center; 
        place-items: center;
    }

    nav {
        display: flex;
        align-items: center;
        padding: 1rem;
        background-color: #0003;
        height: 4rem;
    }

    nav > b {
        font-weight: 900;
        font-size: 2rem;
    }

    #container {
        display: grid;
        grid-template-areas: 
            "nav nav"
            "data header"
            "aside main"
            "footer footer";
        grid-template-columns: calc(350px + 2rem) auto;
        grid-template-rows: 4rem 140px minmax(calc(410px + 2rem), calc(100vh - 4rem - 140px - 8rem)) 4rem;
        gap: 1rem;
    }

    #container > header.main > article,
    #container > main > article {
        transition: background-color 350ms ease-in-out;
        display: grid;
        gap: 1rem;
        grid-template-columns: 50px 140px 140px 140px 140px 140px 140px 140px 140px;
        padding: .35rem 0;
    }

    #container > header.main > article > section,
    #container > main > article > section {
        margin: 0 -.5rem;
    }

    #container > header.aside > article {
        display: grid;
        grid-template-columns: 1fr;
    }

    #container > main {
        overflow-y: scroll;
    }

    #arrows {
        pointer-events: none;
        grid-column-start: 1;
        grid-column-end: 3;
        grid-row: 3;
        z-index: 2;
    }

    main article section {
        margin: 1.5rem 0;
    }

    header article section {
        font-weight: 700;
        margin: 1.5rem 0;
    }

    main article section, 
    header article section {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: .5rem 0;
        flex-wrap: wrap;
    }

    main article section, 
    header article section {
        /* border-left: 1px dotted var(--color-gray-800); */
        border-right: 1px dotted var(--color-gray-800);
    }

    main article section:first-child, 
    header article section:first-child {
        border-left: 1px dotted var(--color-gray-800);
        border-right: 1px dotted var(--color-gray-800);
    }

    header {
        border-bottom: 2px double var(--color-gray-800);
    }

    footer {
        border-top: 2px double var(--color-gray-800);
    }

    :global(.highlight) {
        transition: background-color 350ms ease-in-out;
        background-color: #333;
    }

    :global(body) {
        overflow: hidden;
    }

    #modal {
        position: absolute;
        top: 0; left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 100000;
        background-color: rgba(0, 0, 0, .5);
        backdrop-filter: blur(3px);
        display: flex;
    }

    #modal > section {
        width: min-content;
        margin: auto;
        padding: 2rem;
        border-radius: 1rem;
        background-color: #222;
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
</style>